import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { useOptionalAtom } from '@root/shared/lib'
import { ButtonPurchase } from '@root/shared/ui-kit/buttons'

import type { CurrencySafetyCheck } from '@root/features/premium/check-currency/atoms'
import type { ClassNameProps } from '@root/shared/lib/react'

type Props = {
  result: CurrencySafetyCheck | undefined
  onBuyBoosters: () => void
  onBuySubscription: () => void
} & ClassNameProps

export const PremiumScreenActions: React.FC<Props> = ({
  result,
  onBuyBoosters,
  onBuySubscription,
  className,
}) => {
  const { t } = useTranslation()
  const premium = useOptionalAtom(result?.premiumInfo?.premium) ?? false

  return (
    <Root className={className}>
      <ButtonPurchase
        product="premium"
        radius="rounded"
        variant="secondary"
        size="s"
        disabled={!result || !result.hasPassedSecurityChecks || premium}
        onClick={onBuySubscription}
      >
        {t('premium.button.buy-subscription')}
      </ButtonPurchase>
      <ButtonPurchase
        product="boosters"
        radius="rounded"
        variant="secondary"
        size="s"
        disabled={!result || !result.hasPassedSecurityChecks || !premium}
        onClick={onBuyBoosters}
      >
        {t('premium.button.buy-boosters')}
      </ButtonPurchase>
    </Root>
  )
}

const Root = styled.footer`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  position: relative;

  padding-block: 0 var(--safe-bottom);
  padding-inline: 12px;
`
